import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { MovieCollectComponent } from './movie-collect.component';


const routes: Routes = [
  {
    path: 'movie-collect/:type',
    component: MovieCollectComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class MovieCollectRoutingModule {}
